module.exports = __webpack_public_path__ + "static/media/live-streaming-on.a4bf22b9.svg";